import { render, staticRenderFns } from "./SearchShipper.vue?vue&type=template&id=7c1ecdc6"
import script from "./SearchShipper.vue?vue&type=script&lang=js"
export * from "./SearchShipper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports